import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import xss from "xss";
import { UnsafeJobHtmlRenderer } from "./styles/UnsafeJobHtmlRenderer.mjs";
const xssOptions = {
  whiteList: {
    h2: [],
    p: ["style"],
    b: [],
    strong: [],
    em: [],
    i: [],
    ul: [],
    ol: [],
    li: [],
    br: [],
    hr: [],
    div: [],
    a: ["target", "href", "title", "rel"],
    span: []
  },
  stripIgnoreTag: true,
  stripIgnoreTagBody: true
};
function JobHtmlRenderer({
  children,
  ...rest
}) {
  const sanitisedHtml = useMemo(() => xss(children, xssOptions), [children]);
  return /* @__PURE__ */ jsx(UnsafeJobHtmlRenderer, { ...rest, children: sanitisedHtml });
}
export {
  JobHtmlRenderer,
  UnsafeJobHtmlRenderer
};
